import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelRadio as _vModelRadio, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = {
    class: "bt_modal_open wmax",
    "data-target": "job-modal"
};
const _hoisted_2 = { key: 0 };
const _hoisted_3 = {
    key: 1,
    style: { "color": "#000", "font-size": "24px", "margin": "0" }
};
const _hoisted_4 = {
    key: 0,
    class: "err"
};
const _hoisted_5 = {
    key: 1,
    class: "err"
};
const _hoisted_6 = {
    id: "job-modal",
    class: "modal type1 js-modal"
};
const _hoisted_7 = { class: "modal-content" };
const _hoisted_8 = { class: "pop" };
const _hoisted_9 = ["value", "id", "onChange", "checked"];
const _hoisted_10 = ["for"];
const _hoisted_11 = { key: 0 };
const _hoisted_12 = ["value", "id", "onChange", "checked"];
const _hoisted_13 = ["for"];
const _hoisted_14 = { key: 1 };
const _hoisted_15 = { class: "bt_box clear" };
const _hoisted_16 = { class: "modalBtn-area" };
import { ref, reactive, watch, onBeforeMount } from 'vue';
import Alert from '@util/BrowserAlert';
import ImageFrame from '@component/ImageFrame.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'JobModal',
    props: {
        options: { default: [] },
        form: { default: () => ({}) },
        errors: { default: () => ({}) },
        validateShot: { type: Boolean },
        placeholder: {},
        maxLength: {}
    },
    emits: ['selected'],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const form = reactive({
            job_group_id: '',
            job_group_name: '',
            job_id: '',
            job_name: '',
            other_job_name: '',
        });
        // 選択結果を格納する
        const showResult = ref('');
        const isSelectJob = ref(false);
        // 文字数チェック
        watch(() => form.other_job_name, (value) => {
            if (Alert.charLimitText(value)) {
                form.other_job_name = value.substring(0, Alert.TEXT_LIMIT_NUMBER);
            }
        });
        watch(() => props.options, () => {
            var _a, _b, _c;
            setSelectedName((_a = props.form) === null || _a === void 0 ? void 0 : _a.job_group_id, (_b = props.form) === null || _b === void 0 ? void 0 : _b.job_id, (_c = props.form) === null || _c === void 0 ? void 0 : _c.other_job_name);
        });
        // ラジオ選択
        const onSelectedJob = (jobGroupId, jobId) => {
            form.job_id = jobId;
            form.job_group_id = jobGroupId;
            isSelectJob.value = true;
        };
        // キャンセルボタン
        const onClickCancel = () => {
            var _a, _b, _c;
            isSelectJob.value = false;
            setSelectedName((_a = props.form) === null || _a === void 0 ? void 0 : _a.job_group_id, (_b = props.form) === null || _b === void 0 ? void 0 : _b.job_id, (_c = props.form) === null || _c === void 0 ? void 0 : _c.other_job_name);
        };
        // クリアボタン
        const onClickClear = () => {
            form.job_group_id = null;
            form.job_group_name = '';
            form.job_id = null;
            form.job_name = '';
            form.other_job_name = '';
            isSelectJob.value = false;
            // 全てのチェックを外す
            const radio = document.getElementsByName('job_q1');
            radio.forEach((el) => {
                el.checked = false;
            });
        };
        // OKボタン
        const onClickOK = () => {
            setSelectedName(form.job_group_id, form.job_id, form.other_job_name);
            emit('selected', Object.assign({}, form));
        };
        // 選択内容を表示用の値に入れ込む
        const setSelectedName = (groupId, jobId, otherJobName) => {
            if (isSelectJob.value && (groupId === '' || groupId === null)) {
                showResult.value = `その他`;
                form.other_job_name = 'others';
                return;
            }
            if ((groupId === '' || groupId === null) && otherJobName === '') {
                showResult.value = '';
            }
            else {
                const group = props.options.find((value) => value.id == groupId);
                if (!!jobId) {
                    const job = group === null || group === void 0 ? void 0 : group.jobs.find((value) => value.id == jobId);
                    if (group && job) {
                        if (props.maxLength) {
                            showResult.value = `${group.name} > ${job.name}`.substring(0, props.maxLength);
                        }
                        else {
                            showResult.value = `${group.name} > ${job.name}`;
                        }
                        form.job_group_name = group.name;
                        form.job_name = job.name;
                        form.other_job_name = '';
                    }
                    else {
                        showResult.value = '';
                        form.job_group_name = '';
                        form.job_name = '';
                        form.other_job_name = '';
                    }
                }
                else {
                    if (group) {
                        showResult.value = group.name;
                        form.job_group_name = group.name;
                        form.job_name = '';
                        form.other_job_name = '';
                    }
                    else {
                        if (props.maxLength) {
                            showResult.value = `その他 > ${otherJobName}`.substring(0, props.maxLength);
                        }
                        else {
                            showResult.value = `その他`;
                        }
                        form.job_group_name = 'その他';
                        form.job_name = '';
                        form.other_job_name = otherJobName;
                    }
                }
            }
        };
        onBeforeMount(() => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            form.job_group_id = (_b = (_a = props.form) === null || _a === void 0 ? void 0 : _a.job_group_id) !== null && _b !== void 0 ? _b : null;
            form.job_group_name = (_d = (_c = props.form) === null || _c === void 0 ? void 0 : _c.job_group_name) !== null && _d !== void 0 ? _d : '';
            form.job_id = (_f = (_e = props.form) === null || _e === void 0 ? void 0 : _e.job_id) !== null && _f !== void 0 ? _f : null;
            form.job_name = (_h = (_g = props.form) === null || _g === void 0 ? void 0 : _g.job_name) !== null && _h !== void 0 ? _h : '';
            form.other_job_name = (_k = (_j = props.form) === null || _j === void 0 ? void 0 : _j.other_job_name) !== null && _k !== void 0 ? _k : '';
        });
        return (_ctx, _cache) => {
            var _a, _b;
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("a", _hoisted_1, [
                    (props.placeholder && !showResult.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(props.placeholder), 1))
                        : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(showResult.value), 1)),
                    _createVNode(ImageFrame, { src: "images/common/juji.svg" })
                ]),
                (props.validateShot && ((_a = props.errors) === null || _a === void 0 ? void 0 : _a.job_group_id))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(props.errors.job_group_id), 1))
                    : _createCommentVNode("", true),
                (props.validateShot && ((_b = props.errors) === null || _b === void 0 ? void 0 : _b.job_id))
                    ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(props.errors.job_id), 1))
                    : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", {
                        class: "modal-bg bt_modal_close",
                        onClick: onClickCancel
                    }),
                    _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", {
                            class: "close_bt bt_modal_close",
                            onClick: onClickCancel
                        }, [
                            _createVNode(ImageFrame, { src: "images/common/i_bt_close.svg" })
                        ]),
                        _createElementVNode("div", _hoisted_8, [
                            _cache[3] || (_cache[3] = _createElementVNode("h2", null, "職種を選択してください", -1)),
                            _createElementVNode("dl", null, [
                                _cache[1] || (_cache[1] = _createElementVNode("dt", null, "職種分類", -1)),
                                _cache[2] || (_cache[2] = _createElementVNode("dd", null, "職種", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (groups) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        _createElementVNode("dt", null, [
                                            _createElementVNode("input", {
                                                value: groups.id,
                                                class: "visually-hidden",
                                                type: "radio",
                                                name: "job_q1",
                                                id: `job_group_q1_a${groups.id}`,
                                                onChange: ($event) => (onSelectedJob(groups.id, '')),
                                                checked: form.job_group_id === groups.id && !form.job_id
                                            }, null, 40, _hoisted_9),
                                            _createElementVNode("label", {
                                                for: `job_group_q1_a${groups.id}`
                                            }, _toDisplayString(groups.name), 9, _hoisted_10)
                                        ]),
                                        (groups.id)
                                            ? (_openBlock(), _createElementBlock("dd", _hoisted_11, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.jobs, (job) => {
                                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                        _withDirectives(_createElementVNode("input", {
                                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((form.job_id) = $event)),
                                                            value: job.id,
                                                            class: "visually-hidden",
                                                            type: "radio",
                                                            name: "job_q1",
                                                            id: `job_q1_a${job.id}`,
                                                            onChange: ($event) => (onSelectedJob(groups.id, job.id)),
                                                            checked: form.job_id === job.id
                                                        }, null, 40, _hoisted_12), [
                                                            [_vModelRadio, form.job_id]
                                                        ]),
                                                        _createElementVNode("label", {
                                                            for: `job_q1_a${job.id}`
                                                        }, _toDisplayString(job.name), 9, _hoisted_13)
                                                    ], 64));
                                                }), 256))
                                            ]))
                                            : (_openBlock(), _createElementBlock("dd", _hoisted_14))
                                    ], 64));
                                }), 256))
                            ]),
                            _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("ul", _hoisted_16, [
                                    _createElementVNode("li", null, [
                                        _createElementVNode("button", {
                                            class: "bt_clear",
                                            onClick: _withModifiers(onClickClear, ["prevent"])
                                        }, "クリア")
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createElementVNode("p", {
                                            class: "bt_clear bt_modal_close",
                                            onClick: onClickCancel
                                        }, "キャンセル")
                                    ]),
                                    _createElementVNode("li", null, [
                                        _createElementVNode("p", {
                                            class: "bt_ok bt_modal_close",
                                            onClick: onClickOK
                                        }, "OK")
                                    ])
                                ])
                            ])
                        ])
                    ])
                ])
            ], 64));
        };
    }
});
